import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { UserService } from '../services/services.index';
import { User } from '../interfaces/interfaces.index';

@Injectable({ providedIn: 'root' })

export class LoginGuard implements CanActivate {

    currentUser: User;

    constructor(
        private userService: UserService,
        private router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        this.currentUser = this.userService.user
        if (this.currentUser && !this.currentUser.deleted) {
            return true;
        }
        this.router.navigate(['/login']);
        return false;
    }
}
